module.exports = __webpack_public_path__ + "fonts/SFProDisplay-Regular.7eae39e4.eot";